import { Card, CardHeader, CardContent, Stack, TextField, CardActions, Modal } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { categorySchema } from '../schemas/categorySchemas';
import { createCategory, resetCategoryState } from '../store/categoryActions';

CategoryForm.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default function CategoryForm({ open, onClose }) {
  const dispatch = useDispatch();
  const { isLoading, isSuccess } = useSelector((state) => state.categoryReducer);

  useEffect(() => {
    if (isSuccess) {
      onClose();
    }
  }, [isSuccess, onClose]);

  const onSubmit = async (values) => {
    dispatch(createCategory(values));
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, resetForm } = useFormik({
    initialValues: {
      name: '',
      code: '',
      depreciation_rate: '',
      description: '',
    },
    validationSchema: categorySchema,
    onSubmit,
    isSubmitting: isLoading,
  });

  const handleClose = () => {
    resetForm();
    dispatch(resetCategoryState());
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Card
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '340px', md: '600px' },
          bgcolor: 'background.paper',
          borderRadius: '10px',
          boxShadow: 24,
          p: { xs: '0px', md: '2px' },
          alignItems: 'center',
        }}
      >
        <form onSubmit={handleSubmit}>
          <CardHeader title="Add New Category" />
          <CardContent>
            <Stack spacing={3}>
              <TextField
                fullWidth
                name="name"
                type="text"
                label="Category Name"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name && errors.name}
              />

              <TextField
                fullWidth
                name="code"
                type="text"
                label="Category Code"
                value={values.code}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.code && Boolean(errors.code)}
                helperText={touched.code && errors.code}
              />

              <TextField
                fullWidth
                name="depreciation_rate"
                type="number"
                label="Depreciation Rate (%)"
                value={values.depreciation_rate}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.depreciation_rate && Boolean(errors.depreciation_rate)}
                helperText={touched.depreciation_rate && errors.depreciation_rate}
                inputProps={{ min: 0, max: 100, step: 0.01 }}
              />

              {/* <TextField
                fullWidth
                name="description"
                type="text"
                label="Description (Optional)"
                value={values.description}
                onChange={handleChange}
                onBlur={handleBlur}
                multiline
                rows={3}
                error={touched.description && Boolean(errors.description)}
                helperText={touched.description && errors.description}
              /> */}
            </Stack>
          </CardContent>
          <CardActions sx={{ p: 3, pt: 0 }}>
            <Stack direction="row" spacing={2} sx={{ width: '100%', justifyContent: 'flex-end' }}>
              <LoadingButton variant="outlined" onClick={handleClose} disabled={isLoading}>
                Cancel
              </LoadingButton>
              <LoadingButton type="submit" variant="contained" loading={isLoading} disabled={isSubmitting}>
                Create Category
              </LoadingButton>
            </Stack>
          </CardActions>
        </form>
      </Card>
    </Modal>
  );
}
